import React, { useContext } from "react";
import {
    Col,
    Row,
    Form,
    Input,
    message,
    Select,
    Modal,
    ColorPicker,
} from "antd";
import { useNavigate } from "react-router-dom";
import "dayjs/locale/en";
import { AuthContext } from "../../Auth/AuthContext";
import { createTag } from "../../utils/API";

const { Option } = Select;

interface AddTagModalProps {
    visible: boolean;
    onClose: () => void;
    onTaskCreated: () => void;
    isOpen?: boolean; // optional
}

const AddTagModal: React.FC<AddTagModalProps> = ({
    visible,
    onClose,
    onTaskCreated,
}) => {
    const navigate = useNavigate();
    const { authData } = useContext(AuthContext);
    const [form] = Form.useForm();
    const [isLoading, setIsLoading] = React.useState(false);
    const roleId = authData.roleId;

    const handleSubmit = async (values: any) => {
        try {
            setIsLoading(true);
            const colorValue =
                typeof values.color === "string"
                    ? values.color
                    : values.color?.toHexString?.() || "#000000"; // fallback

            const payload = {
                name: values.name,
                category: values.category,
                color: colorValue, // ColorPicker returns Color object
            };

            await createTag(payload);

            message.success("Tag added successfully!");
            form.resetFields();
            onTaskCreated();
            onClose();
        } catch (error: any) {
            message.error(error.response.data.message)
            console.log(error)
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Modal
            open={visible}
            onCancel={onClose}
            footer={null}
            width={600}
            centered={false}
            destroyOnClose
            className="custom-modal"
            bodyStyle={{
                overflowY: "auto",
                fontFamily: "inter, sans-serif",
            }}
            styles={{
                header: {
                    padding: "12px",
                    position: "sticky",
                    top: 0,
                    backgroundColor: "#f1f5ffff",
                },
                content: {
                    padding: 0,
                    overflow: "hidden",
                },
            }}
            title={
                <div
                    style={{
                        color: "#4b5563",
                        fontFamily: "inter, sans-serif",
                        fontSize: "20px",
                        fontWeight: 500,
                    }}
                >
                    Add Tag
                </div>
            }
        >
            <Form
                onFinish={handleSubmit}
                form={form}
                layout="horizontal"
                labelCol={{ span: 6 }}
                wrapperCol={{ span: 19 }}
                colon={false}
                style={{ margin: 0 }}
            >
                {/* Tag Name + Color Picker side by side */}
                <div className="elements">

                    <div className="flex justify-center gap-4">
                        <Form.Item
                            label={
                                <span style={{
                                    color: '#4b5563',
                                    fontFamily: 'inter, sans-serif',
                                    fontSize: '14px',
                                    paddingLeft: "15px",
                                    fontWeight: 500,
                                }}>
                                    Tag Name <span className="text-red-500">*</span>
                                </span>
                            }
                            name="name"
                            required={false}
                            rules={[{ required: true, message: "Please enter Tag name" }]}
                        >
                            <Input className="Allinput" placeholder="Tag Name" style={{ width: "380px" }} />
                        </Form.Item>

                        <Form.Item

                            required={false}
                            style={{ marginTop: "7px" }}
                            name="color"
                            rules={[{ required: false, message: "Please pick a color" }]}
                        >
                            <ColorPicker
                                format="hex"
                                disabled={false}
                                placement="bottomRight"
                                style={{ marginTop: "0px", position: "relative" }}
                                defaultValue={"#000000"}
                            // showText
                            />
                        </Form.Item>
                    </div>

                    {/* Category */}
                    <Form.Item
                        label={
                            <span style={{
                                color: '#4b5563',
                                fontFamily: 'inter, sans-serif',
                                fontSize: '14px',
                                paddingLeft: "15px",
                                fontWeight: 500,
                            }}>
                                Category <span className="text-red-500">*</span>
                            </span>
                        }
                        name="category"
                        required={false}
                        rules={[
                            {
                                required: true,
                                message: "Please select a category",
                            },
                        ]}
                    >
                        <Select
                            mode="multiple"
                            size="large"
                            disabled={roleId == 2}
                            className="CustomSelect"
                            placeholder="Select category"
                        >
                            <Option value="Sales">Sales</Option>
                            <Option value="Contacts">Contacts</Option>
                        </Select>
                    </Form.Item>
                </div>


                {/* Footer buttons */}
                <Col
                    xs={24}
                    sm={24}
                    md={24}
                    xl={24}
                    xxl={20}
                    className="d-flex justify-content-end me-3"
                >
                    <div className="button-wrapper">
                        <button
                            className="allcanclebutton"
                            onClick={onClose}
                            disabled={isLoading}
                            type="button"
                        >
                            Cancel
                        </button>
                        <button
                            className="allsubmitebutton"
                            disabled={isLoading}
                            type="submit"
                        >
                            {isLoading ? "Adding..." : "Add"}
                        </button>
                    </div>
                </Col>
            </Form>
        </Modal>
    );
};

export default AddTagModal;
